import React from 'react';
import styles from './styles.module.scss';

const SectionLoader: React.FC = () => {
  return (
    <div className={styles.sectionLoader}>
      <div className={styles.skeletonWrapper}>
        <div className={styles.skeletonTitle}></div>
        <div className={styles.skeletonCards}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.skeletonCard}>
              <div className={styles.skeletonImage}></div>
              <div className={styles.skeletonText}></div>
              <div className={styles.skeletonText} style={{ width: '60%' }}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionLoader;
